/**
 * register plugins hooks for vue component
 */

import { Component } from 'vue-property-decorator'

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave'])



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/common/registerHooks.ts